import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import INTOUCH_API from "../../services/Api";
import useCurrentUserData from "../../hooks/useCurrentUserData";
import { useTranslation } from "react-i18next";
const questionnaire = [
  {
    title: "insight_questionnaire_form_page.question1",
    number: 1,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question2",
    number: 2,
    type: "rating",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question3",
    number: 3,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question4",
    number: 4,
    type: "rating",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question5",
    number: 5,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question6",
    number: 6,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question7",
    number: 7,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question8",
    number: 8,
    type: "dropdown",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question9",
    number: 9,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question10",
    number: 10,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question11",
    number: 11,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question12",
    number: 12,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question13",
    number: 13,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question14",
    number: 14,
    type: "text",
    value: "",
  },
  {
    title: "insight_questionnaire_form_page.question15",
    number: 15,
    type: "text",
    value: "",
  },
];

export default function useViewController() {
  const [questions, setQuestions] = useState(() => questionnaire);
  const [questionInfo, setQuestionInfo] = useState(null);
  const [hasChangesForm, setHasChangesForm] = useState(false);
  // BLANK: тема анкеты редактируется прямо в форме (Figma 11691-46635) —
  // первый инпут предзаполняется введённым названием, его правка обновляет
  // и заголовок карточки, и (на сабмите) customTitle обеих анкет пары
  const [blankTitle, setBlankTitle] = useState("");
  const { getUserData } = useCurrentUserData();
  const location = useLocation();
  const { i18n } = useTranslation();

  const onSetQuestions = (event) => {
    setQuestions((prevState) =>
      prevState.map((question) => {
        if (event.target.name === `question-${question.number}`) {
          return {
            ...question,
            value: event.target.value,
          };
        }
        return question;
      })
    );
  };
  const onSetHasChanges = (val) => {
    setHasChangesForm(val);
  };

  const questionName = useMemo(() => {
    // индивидуальная (пустая) анкета: заголовок карточки = тема из инпута формы
    // (live), фолбэк — сохранённое название
    if (questionInfo?.formType === "BLANK") {
      return blankTitle || questionInfo?.customTitle || "";
    }
    if (!questionInfo?.question) return "";
    const user = getUserData();
    const genderSign = user.gender.slice(0, 1);
    const language = i18n.language;

    return questionInfo.question[`${genderSign}_${language}`];
  }, [i18n.language, questionInfo, blankTitle]);

  const isFormValid = useMemo(() => {
    const dropdownEmptyVariants = [":month", ":week", ":year"];
    const hasEmptyDropDown = questions.find((question) =>
      dropdownEmptyVariants.includes(question.value)
    );
    // BLANK: тема обязательна — без неё анкете нечем называться
    const blankTitleOk =
      questionInfo?.formType !== "BLANK" || blankTitle.trim().length > 0;
    return (
      !hasEmptyDropDown &&
      blankTitleOk &&
      questions
        .filter((question) => question.type !== "dropdown")
        .every((question) => question.value.length > 0)
    );
  }, [questions, questionInfo, blankTitle]);

  useEffect(() => {
    // ответы приходят после ухода со страницы (быстрый back/навигация) —
    // без флага setState стрелял по размонтированному компоненту
    let alive = true;
    INTOUCH_API.requestManager(
      "getInsightFormDraftCurrent",
      { payload: location.state.formId },
      (response) => {
        if (alive && response.data) {
          setQuestions(response.data.questions);
        }
      }
    );
    return () => {
      alive = false;
    };
  }, [location.state.formId]);

  useEffect(() => {
    let alive = true;
    INTOUCH_API.requestManager(
      "getInsightFormAnswer",
      { formId: location.state.formId },
      (response) => {
        if (alive) {
          setQuestionInfo(response.data);
          // BLANK: предзаполняем инпут темы сохранённым названием (один раз,
          // чтобы не перетирать правки юзера при обновлениях questionInfo)
          if (response.data?.formType === "BLANK") {
            setBlankTitle((prev) => prev || response.data.customTitle || "");
          }
        }
      }
    );
    return () => {
      alive = false;
    };
  }, [location.state.formId, questionInfo?.question?.id]);

  return {
    questions,
    hasChangesForm,
    onSetQuestions,
    onSetHasChanges,
    questionInfo,
    questionName,
    isFormValid,
    blankTitle,
    setBlankTitle,
  };
}
